import React from 'react'
import { connect } from 'react-redux'
import images from 'helpers/ppfPreview/previewImages'
import nextPossiblePpf from 'helpers/ppfPreview/nextPossiblePpf'
import PpfPreviewControls from './PpfPreviewControls'
import injectSheet from 'react-jss'
import style, { mobileStyle } from './style'
import NightModeSelector from './NightModeSelector'
import mapStateToProps from './selectors'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const imageFinder = mode => {
  switch (mode) {
    case 'conventional':
      return 'night'
    case 'infrared':
      return 'ir'
    case 'superLowLight':
      return 'low'
  }
}

const ppfPreview = ({ distance, ppf, currentCamera, isImperial, classes }) =>
  <div className={classes.container}>
    <div className={classes.previewImage}>
      <div className={classes.topBar}>Day - Ideal</div>
      <img src={images[`day${nextPossiblePpf(ppf, isImperial)}`]} />
    </div>
    <div className={classes.controllsContainer}>
      <div className={classes.topBar} />
      <PpfPreviewControls {...{ distance, ppf, currentCamera, isImperial }} />
    </div>
    <div className={classes.previewImage}>
      <NightModeSelector />
      <img src={images[`${imageFinder(currentCamera.ppfNightMode)}${nextPossiblePpf(ppf, isImperial)}`]} />
    </div>
  </div>

export default connect(mapStateToProps)(injectSheet(style)(ppfPreview))

const mobilePpfPreview = ({ distance, ppf, currentCamera, close, isImperial, classes }) =>
  <div className={classes.mobilePreview}>
    <div className={classes.topBar}>
      <span>Day - Ideal</span>
      <NightModeSelector onMobile />
    </div>
    <div className={classes.imageContainer}>
      <img src={images[`day${nextPossiblePpf(ppf, isImperial)}`]} />
      <img src={images[`${imageFinder(currentCamera.ppfNightMode)}${nextPossiblePpf(ppf, isImperial)}`]} />
    </div>
    <div className={classes.infoContainer}>
      <div className={classes.backButton} onClick={close}>
        <FontAwesomeIcon icon='chevron-left' className={classes.backIcon} />
        Back
      </div>
      <span>{ppf} {isImperial ? 'PPF' : 'PPM'}, Distance: {distance} {isImperial ? 'ft ' : 'm '}</span>
      <div style={{ flex: 1 }} />
    </div>
  </div>

export const MobilePpfPreview = connect(mapStateToProps)(injectSheet(mobileStyle)(mobilePpfPreview))



// WEBPACK FOOTER //
// ./src/components/PpfPreview/index.js